<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener("DOMContentLoaded", function() {
  function traducirFacets() {
    document.querySelectorAll('.facets__text').forEach(function(elemento) {
      const texto = elemento.textContent.trim();

      if (texto === 'Availability') {
        elemento.textContent = 'Disponibilidad';
      } else if (texto === 'Price') {
        elemento.textContent = 'Precio';
      }
    });
  }

  // Ejecutar al cargar
  traducirFacets();

  // Observar cambios dinámicos en el DOM (Shopify vuelve a renderizar los filtros)
  const observer = new MutationObserver(traducirFacets);
  observer.observe(document.body, { childList: true, subtree: true });
});



/* === iosum · ficha de producto con video sin fancybox (22-oct-2026) ===
   Con "Estilo de zoom de imagen" = Ninguno el tema no carga fancybox, pero los videos de la
   galería traen data-fancybox y theme.js le llama .fancybox(): se cae y ya no corre lo que
   sigue en la ficha (aviso de vendidos, guía de tallas, imágenes por variante). Esto deja
   .fancybox() como no-op solo si la librería real no está cargada. */
document.addEventListener("DOMContentLoaded",function(){var $=window.jQuery;if($&&$.fn&&!$.fn.fancybox){$.fn.fancybox=function(){return this}}});
